<template>
  <div>
    <v-dialog v-model="showSortProduct" persistent scrollable>
      <template v-slot:activator="{ on }">
        <v-btn outline color="primary" v-on="on">
          <v-icon class="mr-2">swap_vert</v-icon>
          {{ $t('sort product') }}
        </v-btn>
      </template>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat @click="onClose" small>
            <v-icon>close</v-icon>
          </v-btn>
          <v-divider></v-divider>
        </div>
        <v-card-text class="ma-0" style="height: 600px;">
          <div class="text-xs-center" v-if="!isFirst">
            <v-pagination
              v-model="pageNumber"
              :length="pageCount"
              @input="onClickPageinate"
              class="mb-2"
            ></v-pagination>
          </div>
          <!-- <template v-else>
              <div class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
            </template> -->
          <div
            style="min-height: 500px; height: 500px"
            v-if="loading"
            justify-center
            align-center
            row
          >
            <!-- <v-layout style="height: 400px" > -->
            <div class="spinner text-xs-center">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
            <!-- </v-layout> -->
          </div>
          <template v-else>
            <v-container>
              <v-layout wrap>
                <template v-for="(product, index) in sortproducts">
                  <v-flex xs6 sm3 xl2 class="pa-1" :key="product.id">
                    <sort-product-item v-model="sortproducts[index]" :key="'product_' + product.id">
                      <move-vertical
                        slot="move"
                        :index="(pageNumber - 1) * size + index"
                        :max="totalRecords"
                        @onMove="postMove(product.id, $event, index)"
                        :showForward="true"
                      ></move-vertical>
                    </sort-product-item>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </template>

          <div class="text-xs-center" v-if="!isFirst">
            <v-pagination
              v-model="pageNumber"
              :length="pageCount"
              @input="onClickPageinate"
              class="mb-2"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SortProductItem from './SortProductItem'
import MoveVertical from '@/components/elements/MoveVertical2'
import api from '@/api'
export default {
  data() {
    return {
      showSortProduct: false,
      sortproducts: [],
      loading: true,
      isNoSort: false,
      isChange: false,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      totalRecords: 0,
      isFirst: true
    }
  },
  components: {
    SortProductItem,
    MoveVertical
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    // filterProducts() {
    //   const start = (this.pageNumber - 1) * this.size
    //   const end = start + this.size
    //   return this.sortproducts.slice(start, end)
    // },
    pageCount: function() {
      const vm = this
      let l = this.productCount
      let s = this.size
      if (vm.productBy === 'lineMyShop') {
        return l
      } else {
        return Math.ceil(vm.totalRecords / s)
      }
    },
    offset() {
      return vm.pageNumber * vm.size - vm.size
    }
  },
  async mounted() {
    if (this.showSortProduct) {
      this.getProducts()
      // this.loading = false
      // this.isNoSort = false
      // if (this.isNoSort) {
      //   this.checkMove(true)
      // }
    }
  },
  methods: {
    fetchProducts(pageNumber) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = { pageid: vm.selectedBot.pageid }
        // vm.loadingProduct = true
        // this.loading = true
        vm.productlist = []
        let apiUrl = 'getProducts'
        const page = pageNumber !== undefined ? pageNumber : vm.pageNumber

        data['limit'] = vm.size
        data['offset'] = page * vm.size - vm.size
        data['page'] = page
        if (vm.isKetShop) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }
        if (vm.productBy === 'lineMyShop') {
          apiUrl = 'getProductLineMyShop'
        }

        api[apiUrl](data, function(error, response) {
          if (error && m.productBy === 'lineMyShop') {
            vm.$swal
              .fire({
                title: vm.$t('please_connect_linemyshop'),
                type: 'warning',
                showCancelButton: false,
                reverseButtons: true,
                confirmButtonText: vm.$t('go_connect_linemyshop'),
                confirmButtonColor: vm.$vuetify.theme.primary
              })
              .then(result => {
                if (result.value) {
                  vm.$router.push('partner').catch(() => {})
                }
              })
            // vm.loadingProduct = false
            resolve()
            return
          }

          if (response && response.responsecode === 200) {
            resolve({
              productlist: response.productlist,
              productlist_length: response.productlist_length,
              total_records: response.total_records
            })
            // vm.sortproducts = response.productlist
            // vm.productCount = response.productlist_length
            // vm.totalRecords = response.total_records
          }
          // vm.loadingProduct = false
          // vm.loading = false
          resolve()
        })
      })
    },
    async getProducts() {
      this.loading = true
      try {
        const response = await this.fetchProducts()
        if (response) {
          const { productlist, productlist_length, total_records } = response
          this.sortproducts = productlist
          this.productCount = productlist_length
          this.totalRecords = total_records
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
      this.loading = false
    },
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      this.getProducts()
      $('html, body').animate({ scrollTop: 0 })
    },
    onClose() {
      if (this.isChange) this.$emit('onChangeProduct')
      this.showSortProduct = false
    },
    async postMove(id, direction, index) {
      const moveType = {
        top: 'to_first',
        up: 'to_left',
        down: 'to_right',
        bottom: 'to_last'
      }

      if (direction === 'up' || direction === 'down') {
        const productFrom = this.sortproducts[index]
        let productTo = {}
        const maxPage = Math.ceil(this.totalRecords / this.size)
        if (direction === 'up' && index === 0 && this.pageNumber > 1) {
          const response = await this.fetchProducts(this.pageNumber - 1)
          if (response) {
            const { productlist } = response
            Object.assign(productTo, { ...productlist[this.size - 1] })
          }
        } else if (direction === 'down' && index === this.size - 1 && this.pageNumber < maxPage) {
          const response = await this.fetchProducts(this.pageNumber + 1)
          if (response) {
            const { productlist } = response
            Object.assign(productTo, { ...productlist[0] })
          }
        } else {
          const indexDiff = direction === 'down' ? 1 : -1
          Object.assign(productTo, { ...this.sortproducts[index + indexDiff] })
        }
        try {
          this.loading = true
          const response = await this.post(
            `page/${this.selectedBot.pageid}/swap-product-priority`,
            {
              product_id_1: `${productFrom.id}`,
              priority_1: productFrom.priority,
              product_id_2: `${productTo.id}`,
              priority_2: productTo.priority
            }
          )
          if (response) {
            this.getProducts()
          }
          this.loading = false
        } catch (error) {
          this.loading = false
        }
      } else {
        let input = {
          product_id: id.toString(),
          action_type: moveType[direction]
        }
        this.loading = true
        let vm = this
        api.postUpdateProductPriority({ input, pageid: this.selectedBot.pageid }, function(
          error,
          response
        ) {
          if (error) {
            console.error(error)
            this.isLoading = false
            return
          }
          vm.getProducts()
        })
      }
      this.isChange = true
    },
    onMove(id, direction) {
      var vm = this
      var index = vm.sortproducts.findIndex(el => {
        return el.id == id
      })
      if (index != -1) {
        if (direction == 'up') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index - 1, 1)[0])
          this.checkMove(false, [index, index - 1])
        } else if (direction == 'down') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index + 1, 1)[0])
          this.checkMove(false, [index, index + 1])
        } else if (direction == 'top') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.unshift(product)
          let listindex = []
          for (let c = 0; c <= index; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        } else if (direction == 'bottom') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.push(product)
          let listindex = []
          for (let c = index; c < vm.sortproducts.length; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        }
      } else {
      }
    },
    checkMove: function(isAll, list) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      if (isAll) {
        input = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })
      } else {
        let priority = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })

        input = priority.filter((el, index) => {
          return list.includes(index)
        })
      }

      if (input.length > 0) {
        api.putpriorityproducts({ input, pageid: this.selectedBot.pageid }, function(
          error,
          response
        ) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }
          vm.isChange = true
        })
      }
    }
  },
  watch: {
    showSortProduct: function(newVal, oldVal) {
      if (!newVal && oldVal) this.isChange = false
      if (newVal) {
        this.isFirst = false
        this.getProducts()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SortProduct.vue